import React, { useContext } from 'react';
import { getContext } from 'common';
import { AppToolbarContext } from './';
import Styled from './styles';

export interface AppToolbarContentProps extends React.ComponentPropsWithRef<'div'> {
  /** Content goes here. Content will be right aligned. */
  children: React.ReactNode;
}

/** Place toolbar (right-aligned) content here. For example: <Tabs/>, <IconButton/>.
 * Any other props will be passed to the root element.
*/
const AppToolbarContent = React.forwardRef<HTMLElement, AppToolbarContentProps>((props: AppToolbarContentProps, ref) =>
  getContext(({ RTL }: { RTL: boolean }) => {
    const {
      children,
      ...otherProps
    } = props;
    const appToolbarContext: any = useContext(AppToolbarContext);
    return (
      <Styled.AppToolbarContent
        ref={ref}
        $rtl={RTL}
        $deviceType={appToolbarContext.deviceType}
        {...otherProps}
      >
        {children}
      </Styled.AppToolbarContent>
    );
  }));

AppToolbarContent.displayName = 'AppToolbarContent';

export default AppToolbarContent;
